<template>
  <div class="content elevation-2 rounded p-2 bg-white">
    <div class="header d-flex justify-content-between align-center w-100 px-2">
      <div class="call">
        <h2 class="h2 bold">{{ isVisibleGrouping ? 'Projetos do agrupamento' : (isVisibleLB ? 'Lei do Bem' : 'Lei de Informática') }}</h2>
        <span class="mt-n2" v-if="!isVisibleGrouping">Ficha de projetos enquadrados para {{ isVisibleLB ? 'Lei do Bem' : 'Lei de Informática' }}</span>
        <span class="mt-n2" v-else>Ficha de projetos do agrupamento</span>
      </div>
      <div class="actions">
        <v-btn 
          v-if="isAgrupamento && !isVisibleGrouping" 
          :color="userColor"
          dark
          depressed 
          class="align-center mr-2"
          @click="isVisibleGrouping = true"
        >
          <v-icon left>mdi-format-list-bulleted</v-icon>
          Ver projetos do agrupamento
        </v-btn>
        <v-btn 
          v-if="isVisibleGrouping" 
          color="secondary"
          dark
          depressed 
          class="align-center mr-2" 
          @click="isVisibleGrouping = false"
        >
          <v-icon left>mdi-arrow-left</v-icon>
          Voltar para o formulário
        </v-btn>
        <v-btn
          v-if="canSwapVisualization && !isVisibleGrouping"
          :color="userColor"
          dark
          depressed
          class="align-center"
          @click="toggleVisualization"
        >
          <v-icon left>mdi-file-arrow-left-right-outline</v-icon>
          Visualizar descritivo para {{ isVisibleLB ? 'Lei de Informática' : 'Lei do Bem' }}
        </v-btn>
      </div>
    </div>
    <hr>
    
    <v-alert
      v-if="!canEditStatus"
      type="warning"
      prominent
      border="left"
      class="mx-2 mb-4"
    >
      <div class="d-flex align-center">
        <v-icon left color="warning">mdi-lock</v-icon>
        <div>
          <strong>Projeto bloqueado para edição</strong>
          <p class="mb-0 mt-1">Este projeto está com status "{{ currentStatusLabel }}" e não pode ser editado.</p>
        </div>
      </div>
    </v-alert>
    
    <div class="formularios">
      <template v-if="!isVisibleGrouping">
        <LBEnquadradosForm 
          v-if="isVisibleLB"
          :projeto="projeto"
          :anexos.sync="anexos"
          :anexoTransmissao.sync="anexoTransmissao"
          :anexoComprobatorio.sync="anexoComprobatorio"
          :anexoComprobatorioTerceiro.sync="anexoComprobatorioTerceiro"
          :anexoComprobatorioMateriais.sync="anexoComprobatorioMateriais"
          :anexoJustificativaTrl.sync="anexoJustificativaTrl"
          :anexoAlinhamentoPoliticas.sync="anexoAlinhamentoPoliticas"
          :anexoDesenvolvimentoEmpresas.sync="anexoDesenvolvimentoEmpresas"
          :anexoCronograma.sync="anexoCronograma"
          :isAgrupamento="isAgrupamento"
          :opts="opts"
        ></LBEnquadradosForm>
        <LIEnquadradosForm 
          v-else
          :projeto="projeto" 
          :anexos.sync="anexos"
          :anexoTransmissao.sync="anexoTransmissao"
          :anexoComprobatorio.sync="anexoComprobatorio"
          :anexoComprobatorioTerceiro.sync="anexoComprobatorioTerceiro"
          :anexoCronogramaLi.sync="anexoCronogramaLi"
          :isAgrupamento="isAgrupamento"
          :opts="opts"
        ></LIEnquadradosForm>
      </template>
      <AgrupamentoProjectsList
        v-else
        :projetos="projeto.projetos_agrupados"
        :statusOpts="opts.status"
        @remove-project="handleRemoveProject"
        @add-project="handleAddProject"
        :canEdit="canEdit"
      ></AgrupamentoProjectsList>
    </div>
    <div class="dock-container"
      ref="dockContainer"
      :style="{ top: position.y + 'px', left: position.x + 'px', transform: 'none' }"
      @mousedown="startDrag"
    >
      <div class="dock" :style="dockStyle">
        <div class="d-flex align-center" :style="{ gap: isDockMinimized ? '10px' : '15px' }">
          <div class="dock-handle mr-2" style="cursor: grab; display: flex; align-items: center;">
            <v-icon color="white">mdi-drag-vertical</v-icon>
          </div>
          

          
          <div class="dock-item" @click="showFAQ()" :title="isDockMinimized ? 'FAQ' : ''">
            <v-icon color="white" :class="{ 'mr-2': !isDockMinimized }">mdi-help-circle</v-icon>
            <span v-if="!isDockMinimized" class="white--text font-weight-medium">FAQ</span>
          </div>
          <div class="dock-item" @click="showDispendios()" :title="isDockMinimized ? 'Dispêndios' : ''">
            <v-icon color="white" :class="{ 'mr-2': !isDockMinimized }">mdi-currency-usd</v-icon>
            <span v-if="!isDockMinimized" class="white--text font-weight-medium">Dispêndios</span>
          </div>
          <div class="dock-item" @click="showCronograma()" :title="isDockMinimized ? 'Cronograma' : ''">
            <v-icon color="white" :class="{ 'mr-2': !isDockMinimized }">mdi-calendar-clock</v-icon>
            <span v-if="!isDockMinimized" class="white--text font-weight-medium">Cronograma</span>
          </div>

          <v-menu offset-y top>
            <template v-slot:activator="{ on, attrs }">
              <div class="dock-item" v-bind="attrs" v-on="on" :title="isDockMinimized ? 'Exportações' : ''">
                <v-icon color="white" :class="{ 'mr-2': !isDockMinimized }">mdi-export</v-icon>
                <span v-if="!isDockMinimized" class="white--text font-weight-medium">Exportações</span>
                <v-icon v-if="!isDockMinimized" right color="white" small>mdi-chevron-up</v-icon>
              </div>
            </template>
            <v-list :style="{ background: userColor }" dark dense>
              <template v-if="projeto.trabalho == 3">
                <v-list-item @click="downloadDescritivoPDF(1)">
                  <v-list-item-icon class="mr-2">
                    <v-icon color="white" small>mdi-file-pdf-box</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title class="caption font-weight-medium">Exportar PDF Descritivo LB</v-list-item-title>
                </v-list-item>
                <v-list-item @click="downloadDescritivoPDF(2)">
                  <v-list-item-icon class="mr-2">
                    <v-icon color="white" small>mdi-file-pdf-box</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title class="caption font-weight-medium">Exportar PDF Descritivo LI</v-list-item-title>
                </v-list-item>
              </template>
              <template v-else>
                <v-list-item @click="downloadDescritivoPDF()">
                  <v-list-item-icon class="mr-2">
                    <v-icon color="white" small>mdi-file-pdf-box</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title class="caption font-weight-medium">Exportar PDF Descritivo</v-list-item-title>
                </v-list-item>
              </template>
              <v-list-item @click="downloadCronogramaPDF()">
                <v-list-item-icon class="mr-2">
                  <v-icon color="white" small>mdi-file-pdf-box</v-icon>
                </v-list-item-icon>
                <v-list-item-title class="caption font-weight-medium">Exportar PDF Cronograma</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <div class="dock-item" @click="!hasChanges ? null : onBeforeDoSave()" :class="{ 'disabled': !hasChanges }" :title="isDockMinimized ? 'Salvar' : ''">
            <v-icon :color="hasChanges ? 'white' : 'grey'" :class="{ 'mr-2': !isDockMinimized }">mdi-content-save</v-icon>
            <span v-if="!isDockMinimized" :class="hasChanges ? 'white--text' : 'grey--text'" class="font-weight-medium">Salvar</span>
          </div>

           <div class="dock-item" @click="isDockMinimized = !isDockMinimized" title="Minimizar/Expandir">
             <v-icon color="white">{{ isDockMinimized ? 'mdi-chevron-right' : 'mdi-chevron-left' }}</v-icon>
           </div>
        </div>
        
        <div v-if="!isDockMinimized" class="dock-divider"></div>
        
        <div v-if="!isDockMinimized" class="d-flex align-center">
            <span class="caption white--text opacity-70">
              <v-icon x-small color="white" class="mr-1">mdi-clock-outline</v-icon>
              Última modificação: {{ lastSaved }}
            </span>
        </div>
      </div>
    </div>
    <div class="faq-container">
      <FAQ v-if="isVisibleFAQ" :fields="currentFields" :highlightKey="faqHighlightKey" @close="isVisibleFAQ = false; faqHighlightKey = ''"></FAQ>
      <DispendiosProjetos v-if="isVisibleDispendiosProjetos" :project-id="projeto.id" :benefit="isVisibleLB ? 1 : 2" @close="isVisibleDispendiosProjetos = false"></DispendiosProjetos>
      <CronogramaProjetos v-if="isVisibleCronograma" :ano-base="projeto.ano_base" :benefit="isVisibleLB ? 1 : 2" @close="isVisibleCronograma = false"></CronogramaProjetos>
    </div>

    <GModal ref="confirmModal" appendTitleIcon="mdi-alert" title="Atenção!">
      <p>Você está deixando o descritivo com alterações não salvas.</p>
      <p>O que gostaria de fazer?</p>
      <template v-slot:buttons="{ close }">
        <v-btn
          class="px-3"
          color="primary"
          dark
          depressed
          @click="close(true)"
        >
          Salvar e sair
        </v-btn>
        <v-btn
          class="px-3"
          color="primary"
          dark
          depressed
          @click="close(false)"
        >
          Sair sem salvar
        </v-btn>
        <v-btn
          class="px-3"
          color="secondary"
          depressed
          dark
          @click="close(null)"
        >
          Cancelar
        </v-btn>
      </template>
    </GModal>

    <GModal ref="shouldChangeGroupDate" title="Ajustar data">
      <p v-if="isRemovingProject" class="should-change-group-date">Deseja ajustar as datas do Agrupamento?</p>
      <p v-else class="should-change-group-date">Deseja ajustar as datas dos projetos agrupados?</p>

      <template v-slot:buttons="{ close }">
        <v-spacer />
        <v-btn
          class="px-3 should-change-group-date"
          color="secondary"
          dark
          depressed
          @click="close('cancel')"
        >
          Cancelar
        </v-btn>
        <v-btn
          class="px-3 should-change-group-date"
          color="secondary"
          dark
          depressed
          @click="close('no')"
        >
          Não
        </v-btn>
        <v-btn
          class="px-3 should-change-group-date"
          color="primary"
          dark
          depressed
          @click="close('yes')"
        >
          Sim
        </v-btn>
        <v-spacer />
      </template>
    </GModal>

    <GModal
      ref="confirmStatus"
      appendTitleIcon="mdi-help-box-outline"
      title="Confirmação de status"
    >
      <p>Você está salvando o descritivo do projeto com o status:</p>
      <p>
        <b>{{ currentStatusLabel }}</b>
      </p>
      <template v-slot:buttons="{ close }">
        <v-btn class="px-3" color="primary" dark depressed @click="close(true)">
          Confirmar
        </v-btn>
        <v-btn
          class="px-3"
          color="secondary"
          depressed
          dark
          @click="close(null)"
        >
          Cancelar
        </v-btn>
      </template>
    </GModal>

    <GModal
      ref="confirmClientAccessModal"
      appendTitleIcon="mdi-alert"
      title="Atenção - Acesso do Cliente"
    >
      <p>Você está salvando o projeto com um status que <b>permite acesso do cliente ao descritivo</b>.</p>
      <p>Ao confirmar, o cliente poderá <b>{{ clientAccessText }}</b> o descritivo do projeto.</p>
      <p>Deseja continuar?</p>
      <template v-slot:buttons="{ close }">
        <v-spacer />
        <v-btn
          class="px-3"
          color="secondary"
          dark
          depressed
          @click="close(false)"
        >
          Cancelar
        </v-btn>
        <v-btn
          class="px-3"
          color="primary"
          dark
          depressed
          @click="close(true)"
        >
          Confirmar
        </v-btn>
      </template>
    </GModal>

    <v-dialog v-model="showAddProjectModal" max-width="600px">
      <v-card>
        <v-card-title>Adicionar Projeto ao Agrupamento</v-card-title>
        <v-card-text>
          <v-autocomplete
            v-model="selectedProjectToAdd"
            :items="opts.projetosDesagrupados"
            item-text="titulo"
            item-value="id"
            label="Selecione um projeto"
            return-object
          ></v-autocomplete>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="showAddProjectModal = false">Cancelar</v-btn>
          <v-btn color="primary" @click="confirmAddProject">Adicionar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { BeneficiosEnum, BeneficiosLabels } from "@/core/enums/beneficios";
import { FieldTypeEnum } from "@/core/enums/field-types";
import { StatusProjetoEnum } from "@/core/enums/projetos";
import { AnyAdmin, UserTypeEnum } from "@/core/enums/user-types";
import getDifferences from "@/helpers/getDifferences";
import { projectsOptions } from "@/helpers/yearsOptions";
import _, { cloneDeep, isEmpty } from "lodash";
import moment from "moment";
import Vue from "vue";
import { mapGetters } from "vuex";
import { projetosEnquadradosFields } from "./projetos.enquadrados.fields";
import lbFields from './lb/LBEnquadrados.fields';
import liFields from './li/LIEnquadrados.fields';

export default {
  components: {
    LIEnquadradosForm: () => import("./li/LIEnquadradosForm.vue"),
    LBEnquadradosForm: () => import("./lb/LBEnquadradosForm.vue"),
    FAQ: () => import("./components/FAQProjetos.vue"),
    DispendiosProjetos: () => import("./components/DispendiosProjetos.vue"),
    CronogramaProjetos: () => import("./components/CronogramaProjetos.vue"),
    AgrupamentoProjectsList: () => import("./components/AgrupamentoProjectsList.vue"),    
    GModal: () => import("@/components/g-modal.vue"),
  },
  provide() {
    return {
      openComplexHelp: this.showFAQ,
    };
  },
  computed: {
    ...mapGetters(["clientId", "jwtData", "user"]),
    canEdit: function () {
      const { status } = this.projeto;
      const { tipo_usuario } = this.user;
      // Se 'Em Revisão Galapos' ou 'Em validação final Galapos' somente Galapos pode editar
      // Aprovado para Submissão ou Submetido - ninguém pode editar, mas consultor ainda pode alterar o status
      return (
        ![
          StatusProjetoEnum.APROVADO_SUBMISSAO,
          StatusProjetoEnum.SUBMETIDO,
        ].includes(status) &&
        (![
          StatusProjetoEnum.REVISAO_GALAPOS,
          StatusProjetoEnum.VALIDACAO_FINAL_GALAPOS,
        ].includes(status) ||
          AnyAdmin.includes(tipo_usuario))
      );
    },
    canEditStatus: function () {
      const { status } = this.projeto;
      const { tipo_usuario } = this.user;

      // Aprovado para Submissão ou Submetido - ninguém pode editar, mas consultor ainda pode alterar o status
      return (
        this.canEdit ||
        ([
          StatusProjetoEnum.APROVADO_SUBMISSAO,
          StatusProjetoEnum.SUBMETIDO,
        ].includes(status) &&
          AnyAdmin.includes(tipo_usuario))
      );
    },
    currentStatusLabel: function () {
      const statusValue = this.projeto.status;
      // Buscar o label do opts.status (onde os status são carregados)
      if (this.opts?.status && this.opts.status.length > 0) {
        const statusItem = this.opts.status.find(s => s.id == statusValue);
        if (statusItem) {
          return statusItem.label;
        }
      }
      // Fallback para o label do projeto
      return this.projeto.status_label || 'Desconhecido';
    },
    canGroup: function () {
      return this.userHasAccess("Projetos.agrupamentos.create");
    },
    clientAccessText: function () {
      if (this.pendingStatusChange === StatusProjetoEnum.VALIDACAO_FINAL_CLIENTE) {
        return 'visualizar e editar';
      }
      return 'visualizar';
    },
    contextOptions: function () {
      return [
        {
          name: "Ver ficha de análise",
          limit: -1,
          icon: "",
          show: this.userHasAccess("Projetos.analise.create"),
          cb: ({ id }) => {
            const name = [
              UserTypeEnum.GERENCIAL_CLIENTE,
              UserTypeEnum.COLABORADOR
            ].includes(this.user.tipo_usuario)
              ? "edicao-inclusao-projeto"
              : "ficha-projeto-analise";
            const { href } = this.$router.resolve({
              name,
              params: { projetoId: id }
            });
            window.open(href, "_blank");
          }
        },
        {
          name: "Remover",
          limit: -1,
          icon: "",
          show: this.userHasAccess("Projetos.agrupamentos.create"),
          cb: ({ id, titulo }) => {
            this.showConfirm(
              "Confirmar remoção",
              `Deseja remover ${titulo} do agrupamento?`,
              () => this.projetoSelecaoCustomResource.delete(id)
            );
          },
        },
      ].filter(({ show }) => !!show);
    },
    cols: function () {
      return [
        {
          key: "id_projeto",
          name: "Código",
          hideInform: true,
        },
        {
          key: "titulo",
          name: `Nome do ${this.name}`,
          hideInform: true,
        },
        {
          key: "trabalho",
          name: "Benefício",
          rel: { to: "trabalho", key: "id", name: "nome" },
          hideInform: true,
        },
        {
          key: "ano_base",
          name: "Ano Base",
          hideInform: true,
        },
        {
          key: "data_inicio",
          name: "Data Inicial",
          type: FieldTypeEnum.DATE,
          hideInform: true
        },
        {
          key: "data_fim",
          name: "Data Final",
          type: FieldTypeEnum.DATE,
          hideInform: true
        },
        {
          key: "projetosSelecionados",
          name: "Projetos sem grupo",
          type: FieldTypeEnum.AUTOCOMPLETE_MULTIPLE,
          rel: { to: "projetosDesagrupados", key: "id", name: "titulo" },
          hideInTable: true,
        },
      ];
    },
    plurianualField: function () {
      return [
        {
          key: "ano_base",
          name: "Gerar para o ano:",
          type: FieldTypeEnum.SELECT,
          rules: [{ rule: "required" }],
          rel: { toEdit: projectsOptions, id: "value", name: "text" },
          show: true,
          colSize: this.isAgrupamento ? 4 : 12,
        },
        {
          key: "projetos_agrupados",
          name: "Projetos desse agrupamento que serão replicadas junto do agrupamento",
          placeholder:
            "Nenhum projeto selecionado, agrupamento sera replicado vazio",
          type: FieldTypeEnum.AUTOCOMPLETE_MULTIPLE,
          rel: { to: this.projetosAgrupados, key: "id", name: "titulo" },
          show: this.isAgrupamento,
          colSize: 12,
        },
      ].filter(({ show }) => show);
    },
    plurianualDialogWidth: function () {
      return this.isAgrupamento ? "60%" : "20%";
    },
    fields: function() {
      const fields = _.cloneDeep(projetosEnquadradosFields);

      fields.forEach((field) => {
        field.name = field.name.replace(/Projeto/g, this.name);
      });

      return fields.reduce(
        (acc, field) => ({ ...acc, [field.key]: field }),
        {}
      );
    },
    hasChanges: function () {
      const diff = getDifferences(this.originalProject, this.projeto);
      return !isEmpty(diff);
    },
    isAgrupamento: function() {
      return this.projeto?.agrupamento;
    },
    isGalaposUser: function () {
      return [UserTypeEnum.ADMINISTRADOR, UserTypeEnum.CONSULTOR].includes(
        this.user.tipo_usuario
      );
    },
    isLeiDoBem: function () {
      return [
        BeneficiosEnum.LEI_DO_BEM,
        BeneficiosEnum.LEI_DO_BEM_E_INFORMATICA,
      ].includes(this.projeto?.trabalho);
    },
    isLeiDeInformatica: function () {
      return [
        BeneficiosEnum.LEI_DE_INFORMATICA,
        BeneficiosEnum.LEI_DO_BEM_E_INFORMATICA,
      ].includes(this.projeto?.trabalho);
    },
    lastSaved: function () {
      const { modificado_em } = this.projeto;
      return modificado_em
        ? moment(modificado_em).locale("pt-br").format("LLL")
        : "nunca";
    },
    projetoSelecaoCustomResource: function () {
      const { id, titulo, ano_base, projetos_agrupados } = this.projeto;
      const resource = this.apiResource(
        `/v1/projetos/${this.clientId}/agrupamento`
      );

      const updateAgrupamento = async ({ add = [], exclude = [], needAjustment = false }) => {
        const projetos = projetos_agrupados
          .map(({ id }) => id)
          .concat(add)
          .filter((id) => !exclude.includes(id));
        const body = { ano_base, id, projetos, titulo };

        if (needAjustment) {
          body.precisa_ajustar_datas_agrupamento = true;
        }

        let response = await resource.save(body, id);

        if (response.error) {
          throw response;
        }

        response = await this.doLoad();

        if (response.error) {
          throw response;
        }

        return this.projetosAgrupados;
      };

      return {
        async get() {
          return projetos_agrupados;
        },
        save({ projetosSelecionados }) {
          return updateAgrupamento({ add: projetosSelecionados });
        },
        async delete(id) {
          const action = await this.openConfirmationModal('removeProject');

          switch (action) {
            case 'yes':
              return updateAgrupamento({ exclude: [id], needAjustment: true });
            case 'no':
              return updateAgrupamento({ exclude: [id] });
            default:
              return Promise.resolve();
          }
        },
      };
    },
    resourceProjetos: function () {
      return this.apiResource(`/v1/projetos/${this.clientId}/projeto`);
    },
    resourceProjetosSelecao: function () {
      return this.apiResource(
        `/v1/projetos/${this.clientId}/selecao?ano=${this.projeto.ano_base}`
      );
    },
    resourceStatus: function () {
      return this.apiResource(`/v1/projetos/${this.clientId}/status`);
    },
    isClient: function () {
      return this.getClient().isClient;
    },
    commentsToAdd: function () {
      return _.differenceWith(
        Object.keys(this.fields).filter((k) => !this.fields[k].nao_comenta),
        Object.keys(this.comentarios),
        (k1, k2) => {
          return k1 == k2;
        }
      ).map((k) => ({ key: k, value: this.shortName(this.fields[k].name) }));
    },
    cliente: function() {
      return (
        _.find(this.opts.clientes, c => c.id == this.projeto.empresaId) || {
          trabalho: 0
        }
      );
    },
    hasChangedDate() {
      const { data_inicio: oldIni, data_fim: oldFim } = this.originalProject;
      const { data_inicio: newIni, data_fim: newFim } = this.projeto;
      return oldIni !== newIni || oldFim !== newFim;
    },
    canSwapVisualization: function () {
      return this.projeto?.trabalho === BeneficiosEnum.LEI_DO_BEM_E_INFORMATICA;
    },
    currentFields: function() {
      return this.isVisibleLB ? lbFields : liFields;
    },
    dockStyle: function () {
      const user = this.user || {};
      const { tipo_usuario } = user;
      if (
        [UserTypeEnum.GERENCIAL_CLIENTE, UserTypeEnum.COLABORADOR].includes(
          tipo_usuario
        )
      ) {
        return { background: "rgba(11, 84, 86, 0.9)" };
      }
      return {};
    },
    userColor: function () {
      const user = this.user || {};
      const { tipo_usuario } = user;
      const isClient = [UserTypeEnum.GERENCIAL_CLIENTE, UserTypeEnum.COLABORADOR].includes(tipo_usuario);
      
      if (isClient) {
         return "rgba(11, 84, 86, 0.9)";
      }
      return "#1c1c44";
    },
  },
  beforeRouteLeave: async function (_to, _from, next) {
    if (!this.hasChanges) {
      next();
      return;
    }

    if (!this.$refs.confirmModal) {
      next();
      return;
    }

    const shouldSave = await this.$refs.confirmModal.asyncOpen();

    if (shouldSave) {
      await this.doSave();
    }

    const shouldLeave = shouldSave != null;

    if (shouldLeave) {
      next();
    } else {
      next(false);
    }
  },
  beforeDestroy: function () {
    window.removeEventListener("beforeunload", this.confirmCloseWindow);
    window.removeEventListener("mousemove", this.onDrag);
    window.removeEventListener("mouseup", this.stopDrag);
  },
  mounted() {
    window.addEventListener("mousemove", this.onDrag);
    window.addEventListener("mouseup", this.stopDrag);
    
    // Initialize position to bottom center
    this.$nextTick(() => {
      const dockWidth = this.$refs.dockContainer ? this.$refs.dockContainer.offsetWidth : 300; // Estimate if not rendered
      this.position.x = (window.innerWidth / 2) - (dockWidth / 2);
      this.position.y = window.innerHeight - 100;
    });
  },
  watch: {
    anexos: {
      handler(val) {
        if (this.isLoading) return;
        this.projeto.anexo = val;
      },
      deep: true,
    },
    anexoTransmissao: {
      handler(val) {
        if (this.isLoading) return;
        this.projeto.anexo_transmissao = val;
      },
      deep: true,
    },
    anexoComprobatorio: {
      handler(val) {
        if (this.isLoading) return;
        this.projeto.anexo_comprobatorio = val;
      },
      deep: true,
    },
    anexoComprobatorioTerceiro: {
      handler(val) {
        if (this.isLoading) return;
        this.projeto.anexo_comprobatorio_terceiros = val;
      },
      deep: true,
    },
    anexoComprobatorioMateriais: {
      handler(val) {
        if (this.isLoading) return;
        this.projeto.anexo_comprobatorio_materiais = val;
      },
      deep: true,
    },
    anexoJustificativaTrl: {
      handler(val) {
        if (this.isLoading) return;
        this.projeto.anexo_justificativa_trl = val;
      },
      deep: true,
    },
    anexoAlinhamentoPoliticas: {
      handler(val) {
        if (this.isLoading) return;
        this.projeto.anexo_alinhamento_politicas = val;
      },
      deep: true,
    },
    anexoDesenvolvimentoEmpresas: {
      handler(val) {
        if (this.isLoading) return;
        this.projeto.anexo_desenvolvimento_empresas = val;
      },
      deep: true,
    },
    anexoCronograma: {
      handler(val) {
        if (this.isLoading) return;
        this.projeto.anexo_cronograma = val;
      },
      deep: true,
    },
    anexoCronogramaLi: {
      handler(val) {
        if (this.isLoading) return;
        this.projeto.anexo_cronograma_li = val;
      },
      deep: true,
    },
  },
  created: function () {
    if (!this.clientId) {
      this.$router.push({ name: "listagem-projetos-enquadrados" });
      return;
    }

    this.fetchEnquadrados();    
    window.addEventListener("beforeunload", this.confirmCloseWindow);
    this.doLoad();

    this.resourceStatus.get().then((response) => {
      this.opts.status = response
        .sort((a, b) => a.ordem - b.ordem)
        .reduce((acc, curr) => {
          if (!curr.label && !curr.descricao) {
            return acc;
          }
          
          // Ensure label is set
          if (!curr.label) {
             curr.label = curr.descricao;
          }

          if (
            [
              StatusProjetoEnum.PENDENTE_ANALISE,
              StatusProjetoEnum.ATRASO,
              StatusProjetoEnum.INFORMACOES_PENDENTES,
              StatusProjetoEnum.NAO_ENQUADRADO,
            ].includes(curr.id)
          ) {
            curr.disabled = true;
          }

          return [...acc, curr];
        }, []);
    });

    this.onKeypressDebounce = _.debounce(this.onKeypress, 5100, {
      leading: true,
      trailing: false,
    });
    this.onKeypressKeywordsDebounce = _.debounce(
      this.onKeypressKeywords,
      5100,
      { leading: true, trailing: false }
    );
    this.onPasteDebounce = _.debounce(this.onPaste, 5100, {
      leading: true,
      trailing: false,
    });
    this.onPasteKeywordsDebounce = _.debounce(this.onPasteKeywords, 500, {
      leading: true,
      maxWait: 1000,
      trailing: false,
    });
  },
  methods: {    
    parseJsonArray(value) {
      if (Array.isArray(value)) {
        return value;
      }

      if (!value || value == "") {
        return [];
      }

      try {
        const parsedValue = JSON.parse(value);
        return Array.isArray(parsedValue) ? parsedValue : [];
      } catch (error) {
        return [];
      }
    },
    fetchEnquadrados() {      
      return this.$store.dispatch('projetosLi/fetchAll', this.clientId);
    },
    async downloadDescritivoPDF(beneficioOverride = null) {
        this.$notify({
            group: 'geral',
            title: 'Aguarde',
            text: 'Gerando PDF do descritivo...',
            type: 'info'
        });

        const projetoId = this.$route.params.projetoId;
        const query = beneficioOverride ? `?trabalho=${beneficioOverride}` : '';
        const beneficioName = beneficioOverride === 1 ? 'LB_' : (beneficioOverride === 2 ? 'LI_' : '');
        
        try {
            const response = await this.api().get(`/v1/projetos/${this.clientId}/projeto/${projetoId}/exportar-pdf${query}`, {
                responseType: 'blob'
            });
            
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `Descritivo_Projeto_${beneficioName}${projetoId}.pdf`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            
            this.$notify({
                group: 'geral',
                title: 'Sucesso',
                text: 'PDF gerado com sucesso!',
                type: 'success'
            });
        } catch (err) {
            console.error("Erro ao gerar PDF", err);
            this.$notify({
                group: 'geral',
                title: 'Erro',
                text: 'Erro ao gerar PDF.',
                type: 'error'
            });
        }
    },
    async downloadCronogramaPDF() {
        const benefit = this.isVisibleLB ? 1 : 2;
        const existingAttachment = this.isVisibleLB ? this.anexoCronograma : this.anexoCronogramaLi;
        
        // Check if there's already an attachment
        if (existingAttachment && existingAttachment.length > 0) {
            const confirmed = await new Promise((resolve) => {
                this.showConfirm(
                    'Anexo já existente',
                    'Gerar um novo anexo de cronograma substituirá o anexo existente. Deseja continuar?',
                    () => resolve(true),
                    () => resolve(false)
                );
            });
            
            if (!confirmed) {
                return;
            }
        }
        
        this.$notify({
            group: 'geral',
            title: 'Aguarde',
            text: 'Gerando PDF...',
            type: 'info'
        });

        const projetoId = this.$route.params.projetoId;
        
        let query = `?trabalho=${benefit}`;
        
        try {
            const response = await this.api().get(`/v1/projetos/${this.clientId}/cronograma/${projetoId}/pdf${query}`, {
                responseType: 'blob'
            });
            
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Cronograma_Projeto.pdf');
            document.body.appendChild(link);
            link.click();
            link.remove();
            
            // Reload project data to get the new attachment
            await this.doLoad(true);
            
            this.$notify({
                group: 'geral',
                title: 'Sucesso',
                text: 'Cronograma gerado e anexado com sucesso!',
                type: 'success'
            });
        } catch (err) {
            console.error("Erro ao gerar PDF", err);
            this.$notify({
                group: 'geral',
                title: 'Erro',
                text: 'Erro ao gerar PDF.',
                type: 'error'
            });
        }
    },
    confirmCloseWindow: function (event) {
      if (this.hasChanges) {
        event.preventDefault();
        event.returnValue = true;
      }
    },
    doLoad: function (preserveVisibility = false, skipIsLoadingReset = false) {
      this.isLoading = true;
      return this.resourceProjetos
        .get(this.$route.params.projetoId)
        .then((response) => {
          this.projeto = response.projeto;
          this.projeto.keywords =
            response.projeto.keywords?.split(";").map((word) => word.trim()) ||
            [];

          this.projeto.inovacao = JSON.parse(
            !this.projeto.inovacao || this.projeto.inovacao == ""
              ? "[]"
              : this.projeto.inovacao
          );
          this.inovacao = this.projeto.inovacao;

          this.projeto.decreto = JSON.parse(
            !this.projeto.decreto || this.projeto.decreto == ""
              ? "[]"
              : this.projeto.decreto
          );
          this.decreto = this.projeto.decreto;

          this.projeto.alcance = JSON.parse(
            !this.projeto.alcance || this.projeto.alcance == ""
              ? "[]"
              : this.projeto.alcance
          );
          this.alcance = this.projeto.alcance;
          this.comentarios = JSON.parse(
            !this.projeto.comentario || this.projeto.comentario == ""
              ? "{}"
              : this.projeto.comentario
          );
          this.anexos = Array.isArray(this.projeto.anexo) ? this.projeto.anexo : JSON.parse(this.projeto.anexo || "[]");
          this.anexoTransmissao = Array.isArray(this.projeto.anexo_transmissao) ? this.projeto.anexo_transmissao : JSON.parse(this.projeto.anexo_transmissao || "[]");
          this.anexoComprobatorio = Array.isArray(this.projeto.anexo_comprobatorio) ? this.projeto.anexo_comprobatorio : JSON.parse(this.projeto.anexo_comprobatorio || "[]");
          this.anexoComprobatorioTerceiro = Array.isArray(this.projeto.anexo_comprobatorio_terceiros) ? this.projeto.anexo_comprobatorio_terceiros : JSON.parse(this.projeto.anexo_comprobatorio_terceiros || "[]");
          this.anexoComprobatorioMateriais = Array.isArray(this.projeto.anexo_comprobatorio_materiais) ? this.projeto.anexo_comprobatorio_materiais : JSON.parse(this.projeto.anexo_comprobatorio_materiais || "[]");
          this.anexoJustificativaTrl = Array.isArray(this.projeto.anexo_justificativa_trl) ? this.projeto.anexo_justificativa_trl : JSON.parse(this.projeto.anexo_justificativa_trl || "[]");
          this.anexoAlinhamentoPoliticas = Array.isArray(this.projeto.anexo_alinhamento_politicas) ? this.projeto.anexo_alinhamento_politicas : JSON.parse(this.projeto.anexo_alinhamento_politicas || "[]");
          this.anexoDesenvolvimentoEmpresas = Array.isArray(this.projeto.anexo_desenvolvimento_empresas) ? this.projeto.anexo_desenvolvimento_empresas : JSON.parse(this.projeto.anexo_desenvolvimento_empresas || "[]");
          this.anexoCronograma = Array.isArray(this.projeto.anexo_cronograma) ? this.projeto.anexo_cronograma : JSON.parse(this.projeto.anexo_cronograma || "[]");
          this.anexoCronogramaLi = Array.isArray(this.projeto.anexo_cronograma_li) ? this.projeto.anexo_cronograma_li : JSON.parse(this.projeto.anexo_cronograma_li || "[]");

          this.$set(this.projeto, 'anexo_cronograma', this.anexoCronograma);
          this.$set(this.projeto, 'anexo_cronograma_li', this.anexoCronogramaLi);

          this.projeto.ods_contemplados = this.parseJsonArray(this.projeto.ods_contemplados);

          this.projeto.inovacao_desenvolvimento = JSON.parse(
            !this.projeto.inovacao_desenvolvimento || this.projeto.inovacao_desenvolvimento == ""
              ? "[]"
              : this.projeto.inovacao_desenvolvimento
          );

          /* ENQUANTO NÂO NO PROJETO  */
          if (typeof this.projeto.trabalho == "undefined") {
            this.projeto.trabalho = response.clientes.trabalho;
          }

          this.opts.clientes = [response.clientes];
          this.opts.tipoProjeto = response.tipoProjeto;
          this.opts.alcance = response.alcance;
          this.opts.inovacao = response.inovacao;
          this.opts.areaAplicacao = response.areaAplicacao;
          this.opts.decreto = response.decreto;
          this.opts.tipoPesquisa = response.tipoPesquisa;
          this.opts.areaProjeto = response.areaProjeto
            .map((s) => s.descricao)
            .sort();
          this.opts.natureza = response.natureza;
          this.projetosAgrupados = this.formatProjetosOptions(
            response.projeto.projetos_agrupados
          );

          // Map keywords array to individual fields for LB
          if (this.isLeiDoBem && Array.isArray(this.projeto.keywords)) {
            const keywords = this.projeto.keywords.filter(k => k);
            keywords.forEach((kw, index) => {
              if (index < 5) {
                this.$set(this.projeto, `keyword_${index + 1}`, kw);
              }
            });
          }
          
          this.originalProject = cloneDeep(this.projeto);
                    
          if (!skipIsLoadingReset) {
            this.$nextTick(() => {
              this.isLoading = false;
            });
          }
          
          if (!preserveVisibility) {
            const storageKey = `LB_LI_VISIBILITY_${this.projeto.id}`;
            const storedVisibility = localStorage.getItem(storageKey);
            
            if (this.projeto.trabalho == BeneficiosEnum.LEI_DO_BEM_E_INFORMATICA && storedVisibility !== null) {
              this.isVisibleLB = storedVisibility === 'true';
            } else {
              this.isVisibleLB = this.isLeiDoBem;
            }
          }
          return this.projeto;
        });
    },
    formatProjetosOptions: function (projetos) {
      if (!Array.isArray(projetos)) {
        return [];
      }

      return projetos
        .map((projeto) => {
          const trabalho =
            BeneficiosLabels[projeto.trabalho] || "Sem Benefício";
          const titulo = `${
            projeto.titulo || "Título não encontrado"
          } [${trabalho}]`;
          const disabled = this.projeto.trabalho != projeto.trabalho;
          return { ...projeto, disabled, titulo };
        })
        .sort((a, b) => {
          const { titulo: tituloA, trabalho: trabalhoA } = a;
          const { titulo: tituloB, trabalho: trabalhoB } = b;
          const disabledA = a.disabled ? 1 : 0;
          const disabledB = b.disabled ? 1 : 0;
          return (
            disabledA - disabledB ||
            trabalhoA - trabalhoB ||
            tituloA.localeCompare(tituloB)
          );
        });
    },
    getProjetosDesagrupados: async function () {
      const { projetos } = await this.resourceProjetosSelecao.get();
      const projetosDesagrupados = projetos?.filter(
        ({ agrupamento_id }) => !agrupamento_id
      );
      this.opts.projetosDesagrupados =
        this.formatProjetosOptions(projetosDesagrupados);
    },
    removeFieldFromComment: function (key) {
      Vue.delete(this.comentarios, key);
      this.selectedComment = {};
    },
    toggleVisualization() {
      this.isVisibleLB = !this.isVisibleLB;
      const storageKey = `LB_LI_VISIBILITY_${this.projeto.id}`;
      localStorage.setItem(storageKey, this.isVisibleLB);
      this.doLoad(true);
    },
    addFieldToComment: function (key) {
      Vue.set(this.comentarios, key, "");
      this.selectedComment = {};
    },
    shortName: function (nameField) {
      let idxParentesis = nameField.indexOf(" (");
      return nameField.substring(
        0,
        idxParentesis > 0 ? idxParentesis : nameField.length
      );
    },
    uploadAttachments: async function (attachments) {
      if (!attachments || !attachments.length) return [];
      
      const uploadedAttachments = await Promise.all(attachments.map(async (file) => {
        if (file instanceof File) {
          const formData = new FormData();
          formData.append('file', file);
          
          try {
            const response = await this.apiResource(`/v1/uploads/${this.clientId}`).save(formData);
            
            return response; 
          } catch (error) {
            console.error('Error uploading file:', file.name, error);
            this.$notify({
              group: "geral",
              type: "error",
              title: "Erro no upload",
              text: `Falha ao enviar o arquivo ${file.name}`
            });
            throw error;
          }
        }
        return file; // Already uploaded (metadata object)
      }));
      
      return uploadedAttachments;
    },
    doSave: async function () {
      try {
        // Upload new files first
        this.anexos = await this.uploadAttachments(this.anexos);
        this.anexoTransmissao = await this.uploadAttachments(this.anexoTransmissao);
        this.anexoComprobatorio = await this.uploadAttachments(this.anexoComprobatorio);
        this.anexoComprobatorioTerceiro = await this.uploadAttachments(this.anexoComprobatorioTerceiro);
        this.anexoComprobatorioMateriais = await this.uploadAttachments(this.anexoComprobatorioMateriais);
        this.anexoJustificativaTrl = await this.uploadAttachments(this.anexoJustificativaTrl);
        this.anexoAlinhamentoPoliticas = await this.uploadAttachments(this.anexoAlinhamentoPoliticas);
        this.anexoDesenvolvimentoEmpresas = await this.uploadAttachments(this.anexoDesenvolvimentoEmpresas);
        this.anexoCronograma = await this.uploadAttachments(this.anexoCronograma);
        this.anexoCronogramaLi = await this.uploadAttachments(this.anexoCronogramaLi);
      } catch (e) {
        return; // Stop save if upload fails
      }

      this.projeto.empresaId = this.clientId;
      this.projeto.comentario = JSON.stringify(this.comentarios);
      this.projeto.anexo = this.anexos;
      this.projeto.anexo_transmissao = this.anexoTransmissao;
      this.projeto.anexo_comprobatorio = this.anexoComprobatorio;
      this.projeto.anexo_comprobatorio_terceiros = this.anexoComprobatorioTerceiro;
      this.projeto.anexo_comprobatorio_materiais = this.anexoComprobatorioMateriais;
      this.projeto.anexo_justificativa_trl = this.anexoJustificativaTrl;
      this.projeto.anexo_alinhamento_politicas = this.anexoAlinhamentoPoliticas;
      this.projeto.anexo_desenvolvimento_empresas = this.anexoDesenvolvimentoEmpresas;
      this.projeto.anexo_cronograma = this.anexoCronograma;
      this.projeto.anexo_cronograma_li = this.anexoCronogramaLi;

      const clienteEncontrado = _.find(this.opts.clientes, c => c.id == this.projeto.empresaId);
      if (
        clienteEncontrado &&
        clienteEncontrado.trabalho != 3 &&
        this.projeto.trabalho != clienteEncontrado.trabalho
      ) {
        this.projeto.trabalho = clienteEncontrado.trabalho;
      }

      if (this.hasChangedDate && this.isAgrupamento) {
        const action = await this.openConfirmationModal('editGroup');

        switch (action) {
          case 'yes':
            this.projeto.precisa_ajustar_datas_projetos = true;
            break;
          case 'no':
            break;
          default:
            return;
        }
      }

      const projetoFull = _.cloneDeep(this.projeto);
      projetoFull.ods_contemplados = JSON.stringify(
        this.parseJsonArray(projetoFull.ods_contemplados)
      );
      
      if (this.isVisibleLB) {
        let keywords = "";
        for (let i = 1; i <= 5; i++) {
          if (projetoFull[`keyword_${i}`]) {
            keywords += projetoFull[`keyword_${i}`] + ';';
          }
        }
        projetoFull.keywords = keywords;
      } else {
         projetoFull.keywords = !projetoFull.keywords || !projetoFull.keywords.length
        ? ""
        : Array.isArray(projetoFull.keywords) ? projetoFull.keywords.join("; ") : projetoFull.keywords;
      }

      const projeto = this.getPayload(projetoFull);

      return this.resourceProjetos
        .save(projeto, this.projeto.id)
        .then(async (response) => {
          this.projeto.id = response.id;
          
          const savedAnexos = response.anexo;
          const savedAnexoTransmissao = response.anexo_transmissao;
          const savedAnexoComprobatorio = response.anexo_comprobatorio;
          const savedAnexoComprobatorioTerceiro = response.anexo_comprobatorio_terceiros;
          const savedAnexoComprobatorioMateriais = response.anexo_comprobatorio_materiais;
          const savedAnexoJustificativaTrl = response.anexo_justificativa_trl;
          const savedAnexoAlinhamentoPoliticas = response.anexo_alinhamento_politicas;
          const savedAnexoDesenvolvimentoEmpresas = response.anexo_desenvolvimento_empresas;
          const savedAnexoCronograma = response.anexo_cronograma;
          const savedAnexoCronogramaLi = response.anexo_cronograma_li;

          await this.doLoad(false, true);
          
          this.anexos = Array.isArray(savedAnexos) ? savedAnexos : JSON.parse(savedAnexos || "[]");
          this.anexoTransmissao = Array.isArray(savedAnexoTransmissao) ? savedAnexoTransmissao : JSON.parse(savedAnexoTransmissao || "[]");
          this.anexoComprobatorio = Array.isArray(savedAnexoComprobatorio) ? savedAnexoComprobatorio : JSON.parse(savedAnexoComprobatorio || "[]");
          this.anexoComprobatorioTerceiro = Array.isArray(savedAnexoComprobatorioTerceiro) ? savedAnexoComprobatorioTerceiro : JSON.parse(savedAnexoComprobatorioTerceiro || "[]");
          this.anexoComprobatorioMateriais = Array.isArray(savedAnexoComprobatorioMateriais) ? savedAnexoComprobatorioMateriais : JSON.parse(savedAnexoComprobatorioMateriais || "[]");
          this.anexoJustificativaTrl = Array.isArray(savedAnexoJustificativaTrl) ? savedAnexoJustificativaTrl : JSON.parse(savedAnexoJustificativaTrl || "[]");
          this.anexoAlinhamentoPoliticas = Array.isArray(savedAnexoAlinhamentoPoliticas) ? savedAnexoAlinhamentoPoliticas : JSON.parse(savedAnexoAlinhamentoPoliticas || "[]");
          this.anexoDesenvolvimentoEmpresas = Array.isArray(savedAnexoDesenvolvimentoEmpresas) ? savedAnexoDesenvolvimentoEmpresas : JSON.parse(savedAnexoDesenvolvimentoEmpresas || "[]");
          this.anexoCronograma = Array.isArray(savedAnexoCronograma) ? savedAnexoCronograma : JSON.parse(savedAnexoCronograma || "[]");
          this.anexoCronogramaLi = Array.isArray(savedAnexoCronogramaLi) ? savedAnexoCronogramaLi : JSON.parse(savedAnexoCronogramaLi || "[]");
          
          
          this.$set(this.projeto, 'anexo', this.anexos);
          this.$set(this.projeto, 'anexo_transmissao', this.anexoTransmissao);
          this.$set(this.projeto, 'anexo_comprobatorio', this.anexoComprobatorio);
          this.$set(this.projeto, 'anexo_comprobatorio_terceiros', this.anexoComprobatorioTerceiro);
          this.$set(this.projeto, 'anexo_comprobatorio_materiais', this.anexoComprobatorioMateriais);
          this.$set(this.projeto, 'anexo_justificativa_trl', this.anexoJustificativaTrl);
          this.$set(this.projeto, 'anexo_alinhamento_politicas', this.anexoAlinhamentoPoliticas);
          this.$set(this.projeto, 'anexo_desenvolvimento_empresas', this.anexoDesenvolvimentoEmpresas);
          this.$set(this.projeto, 'anexo_cronograma', this.anexoCronograma);
          this.$set(this.projeto, 'anexo_cronograma_li', this.anexoCronogramaLi);
          
          this.originalProject = cloneDeep(this.projeto);
          
          this.$nextTick(() => {
            this.isLoading = false;
          });

          return response;
        });
    },
    getPayload: function(projectData) {
      const commonFields = [
        'id', 'empresaId', 'ano_base', 'titulo', 'id_projeto', 'responsavelTxt', 'trabalho', 'status', 
        'agrupamento', 'data_inicio', 'data_fim', 'precisa_ajustar_datas_projetos', 'keywords', 
        'responsaveis', 'propriedade_intelectual', 'comentario', 'anexo', 'anexo_transmissao', 
        'anexo_comprobatorio', 'anexo_comprobatorio_terceiros', 'anexo_comprobatorio_materiais', 'anexo_cronograma', 'anexo_cronograma_li',
        'area_conhecimento_projeto', 'precisa_ajustar_datas_agrupamento', 'area_projeto_outro'
      ];

      const lbKeys = this.extractKeys(lbFields);
      const liKeys = this.extractKeys(liFields);

      const specificKeys = this.isVisibleLB ? lbKeys : liKeys;
      
      const allowedKeys = new Set([...commonFields, ...specificKeys]);
      
      const payload = {};
      Object.keys(projectData).forEach(key => {
        if (allowedKeys.has(key)) {
          payload[key] = projectData[key];
        }
      });
      
      return payload;
    },
    extractKeys(fieldsDef) {
       let keys = [];
       Object.values(fieldsDef).forEach(section => {
          section.forEach(field => keys.push(field.key));
       });
       return keys;
    },
    gerarProximoAnoBase: function ({ ano_base, projetos_agrupados }) {
      const dataFimProjeto = this.projeto.data_fim;
      const dataAnoBase = moment(dataFimProjeto).get("year");
      if (dataFimProjeto && dataAnoBase < ano_base) {
        const dataFimExibicao = moment(dataFimProjeto).format("DD/MM/YYYY");
        this.showConfirm(
          `Projeto encerrado em ${dataFimExibicao}`,
          `Deseja prosseguir com a replicação do projeto para o ano ${ano_base}? O novo projeto será criado com data fim indefinida.`,
          () => {
            this.gerarAnoBase(ano_base, projetos_agrupados);
          }
        );
      } else {
        this.gerarAnoBase(ano_base, projetos_agrupados);
      }
    },
    gerarAnoBase: function (ano_base, projetos_agrupados) {
      this.apiResource(
        `v1/projetos/${this.clientId}/plurianual/${this.projeto.id}`
      )
        .save({ ano_base, projetos_agrupados })
        .then((response) => {
          if (response.error) {
            return;
          }

          this.plurianualDialog = false;
          const route = this.$router.resolve({
            name: "ficha-projeto-enquadrado",
            params: { projetoId: response.id },
          });
          window.open(route.href, "_blank");
        });
    },
    onPlurianualOpen: function () {
      this.plurianualData = {
        projetos_agrupados: this.isAgrupamento
          ? this.projeto.projetos_agrupados.map(({ id }) => id)
          : undefined,
      };
    },
    onKeypress: function (event) {
      const checkLength = () => {
        const { maxLength, value } = event.target;

        if (maxLength > -1 && value.length >= maxLength) {
          this.$notify({
            group: "geral",
            duration: 5000,
            type: "alert",
            title: "Limite de caracteres atingido",
            text: `Você não pode inserir mais de ${maxLength} caracteres neste campo.`,
          });
        }
      };

      // Compensar o delay entre o evento keypress e o change do componente
      setTimeout(checkLength, 100);
    },
    onKeypressKeywords: function (event) {
      const { maxLength, length } = event.target;
      if (maxLength > -1 && length >= maxLength) {
        this.$notify({
          group: "geral",
          duration: 5000,
          type: "alert",
          title: "Limite de caracteres atingido",
          text: `Você não pode inserir mais de ${maxLength} caracteres neste campo.`,
        });
      }
    },
    onPaste: function (event) {
      const currText = event.target.value;
      const maxLength = event.target.maxLength;
      const pasteText = event.clipboardData.getData("text");
      const nextLength = currText.length + pasteText.length;

      if (maxLength > -1 && nextLength > maxLength) {
        event.preventDefault();
        this.$notify({
          group: "geral",
          duration: 5000,
          type: "alert",
          title: "Ação colar interrompida",
          text: `A ação iria exceder o limite de ${maxLength} caracteres do campo (iria para ${nextLength} caracteres).`,
        });
      }
    },
    onPasteKeywords: function ({ target, pasteData }) {
      const { maxLength, value } = target;
      const parsedValue = value.join("; ");
      const nextLength = parsedValue.length + pasteData.length;

      if (
        maxLength > -1 &&
        nextLength > maxLength &&
        parsedValue !== pasteData
      ) {
        this.$notify({
          group: "geral",
          duration: 5000,
          type: "alert",
          title: "Ação colar interrompida",
          text: `A ação iria exceder o limite de ${maxLength} caracteres do campo (iria para ${nextLength} caracteres).`,
        });
      }
    },
    onBeforeDoSave: async function () {
      const novoStatus = this.projeto.status;
      const statusPermiteAcessoCliente = [
        StatusProjetoEnum.VALIDACAO_FINAL_CLIENTE,
        StatusProjetoEnum.APROVADO_SUBMISSAO,
        StatusProjetoEnum.SUBMETIDO
      ];
      
      // Verifica se o status permite acesso do cliente
      if (statusPermiteAcessoCliente.includes(novoStatus)) {
        this.pendingStatusChange = novoStatus;
        const confirmadoAcesso = await this.$refs.confirmClientAccessModal.asyncOpen();
        if (!confirmadoAcesso) {
          this.pendingStatusChange = null;
          return;
        }
        this.pendingStatusChange = null;
      }
      
      const confirmModal = await this.$refs.confirmStatus.asyncOpen();
      if (confirmModal) {
        await this.doSave();
      }
    },
    openConfirmationModal(type = 'editGroup') {
      this.isRemovingProject = type === 'removeProject';
      return this.$refs.shouldChangeGroupDate.asyncOpen();
    },
    onAnexoTransmissaoChanged(value) {
      this.projeto.anexo_transmissao = value;
    },
    onAnexoChanged(value) {
      this.projeto.anexo = value;
    },
    onChangeAnexoComprobatorio: function (value) {
      this.projeto.anexo_comprobatorio = value;
    },
    onChangeAnexoComprobatorioTerceiros: function (value) {
      this.projeto.anexo_comprobatorio_terceiros = value;
    },
    showFAQ(key) {
      if (key) {
        this.faqHighlightKey = key;
      }
      this.isVisibleFAQ = true;
    },
    showDispendios() {
      this.menu = false;
      this.isVisibleDispendiosProjetos = true;
    },
    showCronograma() {
      this.menu = false;
      this.isVisibleCronograma = true;
    },

    startDrag(e) {
      if (e.target.closest(".dock-item")) return; // evita arrastar ao clicar nos itens
      this.dragging = true;
      this.offset.x = e.clientX - this.position.x;
      this.offset.y = e.clientY - this.position.y;
    },
    onDrag(e) {
      if (!this.dragging) return;
      
      let newX = e.clientX - this.offset.x;
      let newY = e.clientY - this.offset.y;

      // Boundaries
      const dockRect = this.$refs.dockContainer.getBoundingClientRect();
      const maxX = window.innerWidth - dockRect.width;
      const maxY = window.innerHeight - dockRect.height;

      this.position.x = Math.min(Math.max(0, newX), maxX);
      this.position.y = Math.min(Math.max(0, newY), maxY);
    },
    stopDrag() {
      this.dragging = false;
    },
    handleRemoveProject(projectToRemove) {
      const projetosAgrupados = this.projeto.projetos_agrupados || [];
      
      // Se há apenas 1 projeto, chamar a lógica de desfazer agrupamento
      if (projetosAgrupados.length <= 1) {
        this.showConfirm(
          "Confirmar desagrupamento",
          `Este é o último projeto do agrupamento "${this.projeto.titulo}". Deseja desfazer o agrupamento? Os projetos voltarão a aparecer na listagem de projetos.`,
          async () => {
            try {
              // Desfazer agrupamento: salvar com lista vazia de projetos
              const body = {
                ano_base: this.projeto.ano_base,
                id: this.projeto.id,
                projetos: [],
                titulo: this.projeto.titulo,
              };
              
              const resourceAgrupamento = this.apiResource(`/v1/projetos/${this.clientId}/agrupamento`);
              await resourceAgrupamento.save(body, this.projeto.id);
              
              // Perguntar se deseja excluir o agrupamento também
              this.showConfirm(
                "Confirmar exclusão do agrupamento",
                `Deseja excluir o agrupamento "${this.projeto.titulo}"? Os dados do descritivo do agrupamento serão perdidos. Essa ação não pode ser desfeita.`,
                async () => {
                  await resourceAgrupamento.delete(this.projeto.id);
                  this.$notify({
                    group: "geral",
                    duration: 5000,
                    type: "success",
                    title: "Agrupamento excluído",
                    text: "O agrupamento foi desfeito e excluído com sucesso.",
                  });
                  // Redirecionar para a listagem de projetos
                  this.$router.push({ name: "listagem-projetos-enquadrados" });
                },
                () => {
                  // Se não excluir, apenas recarregar os dados
                  this.$notify({
                    group: "geral",
                    duration: 5000,
                    type: "success",
                    title: "Agrupamento desfeito",
                    text: "Os projetos voltaram a aparecer na listagem.",
                  });
                  this.$router.push({ name: "listagem-projetos-enquadrados" });
                }
              );
            } catch (error) {
              this.$notify({
                group: "geral",
                duration: 5000,
                type: "error",
                title: "Erro",
                text: "Ocorreu um erro ao desfazer o agrupamento.",
              });
            }
          }
        );
        return;
      }
      
      // Comportamento normal: remover projeto do agrupamento
      this.showConfirm(
        "Confirmar remoção",
        `Deseja remover o projeto "${projectToRemove.titulo}" do agrupamento?`,
        async () => {
          const action = await this.openConfirmationModal('removeProject');
          
          const { id, titulo, ano_base, projetos_agrupados } = this.projeto;
          const resourceAgrupamento = this.apiResource(`/v1/projetos/${this.clientId}/agrupamento`);
          
          const projetos = projetos_agrupados
            .map(({ id }) => id)
            .filter((pid) => pid !== projectToRemove.id);
          
          const body = {
            ano_base,
            id,
            projetos,
            titulo,
          };
          
          if (action === 'yes') {
            body.precisa_ajustar_datas_agrupamento = true;
          } else if (action === 'cancel') {
            return;
          }
          
          try {
            await resourceAgrupamento.save(body, id);
            await this.doLoad();
            this.$notify({
              group: "geral",
              duration: 5000,
              type: "success",
              title: "Projeto removido",
              text: `O projeto "${projectToRemove.titulo}" foi removido do agrupamento.`,
            });
          } catch (error) {
            this.$notify({
              group: "geral",
              duration: 5000,
              type: "error",
              title: "Erro",
              text: "Ocorreu um erro ao remover o projeto do agrupamento.",
            });
          }
        }
      );
    },
    handleAddProject() {
      this.getProjetosDesagrupados();
      this.showAddProjectModal = true;
    },
    confirmAddProject() {
      if (this.selectedProjectToAdd) {
        if (!this.projeto.projetos_agrupados) {
          this.$set(this.projeto, 'projetos_agrupados', []);
        }
        // Check if already added
        if (!this.projeto.projetos_agrupados.find(p => p.id === this.selectedProjectToAdd.id)) {
             this.projeto.projetos_agrupados.push(this.selectedProjectToAdd);
        }
        this.showAddProjectModal = false;
        this.selectedProjectToAdd = null;
      }
    },
  },
  data: function () {
    return {
      isLoading: false,
      isRemovingProject: false,
      pendingStatusChange: null,
      isVisibleGrouping: false,
      isVisibleFAQ: false,
      isVisibleDispendiosProjetos: false,
      isVisibleCronograma: false,
      isVisibleLB: false,
      showAddProjectModal: false,
      selectedProjectToAdd: null,
      
      // Dragging
      dragging: false,
      position: { x: 0, y: 0 }, // Initialized in mounted
      offset: { x: 0, y: 0 },

      onKeypressDebounce: () => {},
      onKeypressKeywordsDebounce: () => {},
      onPasteDebounce: () => {},
      onPasteKeywordsDebounce: () => {},
      projetosAgrupados: [],
      plurianualDialog: false,
      plurianualData: {},      
      faqHighlightKey: '',
      status: [],
      selectedComment: null,
      currentStep: 0,
      currentView: 0,
      anexos: [],
      inovacao: [],
      decreto: [],
      alcance: [],
      comentarios: {},
      originalProject: {},
      anexoTransmissao: [],
      anexoComprobatorio: [],
      anexoComprobatorioTerceiro: [],
      anexoComprobatorioMateriais: [],
      anexoJustificativaTrl: [],
      anexoAlinhamentoPoliticas: [],
      anexoDesenvolvimentoEmpresas: [],
      anexoCronograma: [],
      anexoCronogramaLi: [],
      projeto: {
        id: null,
        trabalho: null,
        id_projeto: null,
        criado_em: null,
        modificado_em: null,
        empresaId: null,
        consultorId: null,
        // responsavelId: null,
        responsavelTxt: null,
        titulo: null,
        resumo: null,
        anexo: null,
        descricao: null,
        enquadramento: null,
        status: null,
        data_analise: null,
        data_inicio: null,
        data_fim: null,
        ano_base: null,
        tipo_projetoId: null,
        troca_ppb: null,
        area_aplicacaoId: null,
        qtde_publicacoes: null,
        tipo_pesquisaId: null,
        area_projeto: null,
        area_conhecimento_projeto: null,
        keywords: [],
        keyword_li: null,
        naturezaId: null,
        elemento_tecnologico: null,
        desafio_tecnologico: null,
        metodologia: null,
        atividade_continua: null,
        info_complementar: null,
        resultado_economico: null,
        resultado_inovacao: null,
        projetos_agrupados: [],
        recursos_humanos: null,
        vinculacao_materiais: null,
        anexo_transmissao: null,
        anexo_comprobatorio: null,
        anexo_comprobatorio_terceiros: null,
        anexo_comprobatorio_materiais: null,
        nivel_trl_inicial: null,
        nivel_trl_final: null,
        justificativa_trl: null,
        anexo_justificativa_trl: null,
        anexo_cronograma: null,
        anexo_cronograma_li: null,
      },
      opts: {
        alcance: [],
        areaAplicacao: [],
        areaProjeto: [],
        clientes: [],
        colaboradores: [],
        inovacao: [],
        decreto: [],
        tipoProjeto: [],
        status: [],
        tipoPesquisa: [],
        natureza: [],
        projetosDesagrupados: [],
        nivelTrl: [
          {
            id: 1,
            descricao: 'TRL 1 / MRL 1 / STRL 1 / TRL 1'
          },
          {
            id: 2,
            descricao: 'TRL 2 / MRL 2 / STRL 2 / TRL 2'
          },
          {
            id: 3,
            descricao: 'TRL 3 / MRL 3 / STRL 3 / TRL 3'
          },
          {
            id: 4,
            descricao: 'TRL 4 / MRL 4 / STRL 4 / TRL 4'
          },
          {
            id: 5,
            descricao: 'TRL 5 / MRL 5 / STRL 5 / TRL 5'
          },
          {
            id: 6,
            descricao: 'TRL 6 / MRL 6 / STRL 6 / TRL 6'
          },
          {
            id: 7,
            descricao: 'TRL 7 / MRL 7 / STRL 7 / TRL 7'
          },
          {
            id: 8,
            descricao: 'TRL 8 / MRL 8 / STRL 8 / TRL 8'
          },
          {
            id: 9,
            descricao: 'TRL 9 / MRL 9 / STRL 9 / TRL 9'
          },
        ],
        trabalho: [
          {
            id: 0,
            nome: "Nenhum",
            disabled: true, // essa opção pode vir assim, mas não deve ser selecionavel
          },
          {
            id: BeneficiosEnum.LEI_DO_BEM,
            nome: BeneficiosLabels.LEI_DO_BEM,
          },
          {
            id: BeneficiosEnum.LEI_DE_INFORMATICA,
            nome: BeneficiosLabels.LEI_DE_INFORMATICA,
          },
          {
            id: BeneficiosEnum.LEI_DO_BEM_E_INFORMATICA,
            nome: BeneficiosLabels.LEI_DO_BEM_E_INFORMATICA,
          },
        ],
      },
      isDockMinimized: false,
    };
  },

};
</script>

<style lang="scss" scoped>
.v-progress-linear__content {
  .v-btn > .v-btn__content .v-icon,
  .v-label-input {
    &,
    & .theme--light.v-icon {
      color: rgba(255, 255, 255, 0.87);
    }
  }
}

::v-deep .theme--dark.v-icon.v-icon.v-icon--disabled {
  color: rgba(0, 0, 0, 0.12) !important;
  background-color: rgba(255, 255, 255, 0.12) !important;
}

::v-deep .v-btn:disabled,
.theme--dark.v-btn:disabled,
.theme--dark.v-btn:disabled:not(.v-btn--flat):not(.v-btn--text):not(
    .v-btn--outlined
  ) {
  background-color: rgba(0, 0, 0, 0.12) !important;
  color: rgba(0, 0, 0, 0.28) !important;
}

.ex-panel-no-padding .v-expansion-panel-content__wrap {
  padding: 0px;
}

.ex-panel-no-padding .v-expansion-panel--active > .v-expansion-panel-header {
  min-height: auto;
}

.dock-container {
  position: fixed;
  z-index: 9999;
  cursor: grab;
}

.dock-container:active {
  cursor: grabbing;
}

.dock {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: rgba(28, 28, 68, 0.9);
  backdrop-filter: blur(12px);
  padding: 10px 20px;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.15);
  gap: 5px;
  transition: all 0.3s ease;
}

.dock-item {
  position: relative;
  cursor: pointer;
  transition: transform 0.2s ease;
  display: flex;
  justify-content: center;
  align-items: center;
}

.dock-item:hover {
  transform: scale(1.2) translateY(-5px);
}

.dock-item.disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.dock-item.disabled:hover {
  transform: none;
}

.dock-divider {
  width: 100%;
  height: 1px;
  background-color: rgba(255, 255, 255, 0.1);
  margin: 5px 0;
}

.content {
    margin-bottom: 30px;
}
</style>
